import PropTypes from "prop-types";
import { connect, useRouter, Cookie } from "../../atoms/DependencyHelper";
import {
  setPaymentMethod,
  setShippingMethodsOnCartService,
} from "../../../services/checkoutService";
import {
  showSpinner,
  hideSpinner,
  getCookieValue,
  urlPrefix,
  imagePrefix,
  generateFormURL,
  getOrderCreated,
  setCookieConsentWrapper,
  cartUpdateEvent,
  getSessionStorage,
} from "../../../utils/helperServices";
import {
  Features
} from "../../../utils/featuresService";
import axios from "axios";
import { STREET_ADDR, BUILDING_ADDR } from "../../../config/constants";
import ajaxService from "../../../utils/ajaxServices";
import microService from "../../../utils/microServices";
import * as Analytics from "../../../services/analyticsUtag";
import labels from "../../../config/labels";
import config from "../../../config/index";
import { productOrderReq } from "../../../data/mockRenderComponent";
import { journeyType } from "../../../context/checkout-journey-context";
import { setPostOrderResponse } from "../../../Redux/actions/checkoutAction";
import {
  setChangeStore,
  setChangeMethods,
  setStoreDetails,
} from "../../../Redux/actions/geoLocationAction";

import {
  Logger,
} from "../../../utils/logger";

import styles from "./ButtonPayment.module.scss";

const ButtonPayment = ({
  btnSecure,
  btnLable,
  btnDisabled,
  navigate,
  customerStatus,
  setPageErr,
  deal,
  dealID,
  applicationType,
  cartDetails,
  currentJourneyType,
  authDetailsData,
  paymentMethodCode,
  shippingAddress,
  addressTypes,
  selectedUpgradeMsisdn,
  unMaskedMsisdn,
  pageName,
  geoLocation,
  creditVettingDetails,
  paymentOptionsEnabled,
  setPostOrderResponse,
  setChangeStore,
  setChangeMethods,
  setStoreDetails,
  continueDisable,
  selectedUpgradeResponse,
}) => {
  const router = useRouter();
  const cartId = getCookieValue("cart_id");
  const otpAuthtoken = getCookieValue("vod-web-auth-otp-token");
  const authToken = getCookieValue("auth_token");
  const vodAuthToken = getCookieValue("vod-web-auth-token");

  let carrierCode =
    cartDetails?.selected_shipping_method?.carrier_code == "clickandcollect"
      ? "clickandcollect"
      : cartDetails?.shippingFeeCalculate?.carrier_code;
  let methodCode =
    cartDetails?.selected_shipping_method?.method_code == "clickandcollect"
      ? "clickandcollect"
      : cartDetails?.shippingFeeCalculate?.method_code;

  const totalZero =
    parseFloat(cartDetails?.shippingFeeCalculate?.shipping_fee) +
      parseFloat(cartDetails?.prices?.grand_total?.value) ==
    parseFloat(0)
      ? "true"
      : "false";
  const addressTypesOptions = addressTypes ? addressTypes : [];

  const createStreetString = (arr) => {
    let res = "";
    if (Array.isArray(arr) && arr.length > 0) {
      res = arr.join(", ");
    }
    return res;
  };

  /**
   * Upgrade customer request payload
   *
   * @usage map the key-value pair request
   */
  const mapUpgradeData = () => {
    let dealPrice;
    let sessionMsisdn = sessionStorage.getItem('upgradeMsisdn')
    try {
      dealPrice = deal[0]?.monthly_recurring.toString();
    } catch (error) {
      dealPrice = "0";
    }

    const addressType = addressTypesOptions.filter(
      (address) => address.id == shippingAddress?.address_type_name
    );
    if (!selectedUpgradeMsisdn || !unMaskedMsisdn) {
      Analytics.error(
        `Upgrade Journey: Missing MSISDN ${selectedUpgradeMsisdn}`
      );
    }
    if (
      currentJourneyType === journeyType.upgrade &&
      (!selectedUpgradeMsisdn && !unMaskedMsisdn && !sessionMsisdn)
    ) {
      hideSpinner();
      handleMissingMsisdn(
        "chk-dxl-p-po-200",
        "Upgrade journey missing msisdn"
      );
    }

    const sessionCartSummary = getSessionStorage(labels.Session_Keys.lbl_cart_summary);
    const cssHandsetDetails = Array.isArray(sessionCartSummary)
      ? sessionCartSummary.map((item) => ({
        productSKUCode: item.line500CODE,
        familyGroupId: item.groupid
      }))
      : [];

    return {
      context: "UPGRADE",
      dealSheetId: dealID,
      idNumber: authDetailsData?.idNumber,
      idType: authDetailsData?.idType,
      upgradeMsisdn: selectedUpgradeMsisdn
        ? selectedUpgradeMsisdn
        : unMaskedMsisdn
        ? unMaskedMsisdn
        : sessionMsisdn
        ? sessionMsisdn
        : null,
      dealCost: dealPrice,
      updateAddressDetails: {
        inputType: "ADDRESS",
        addressType: addressType[0] ? addressType[0]?.label : "Residential",
        addressDetails: {
          addressType: shippingAddress?.complex_name
            ? BUILDING_ADDR
            : STREET_ADDR,
          buildingName: shippingAddress?.company ? shippingAddress.company : "",
          city: shippingAddress?.city ? shippingAddress.city : "",
          complexName: shippingAddress?.complex_name
            ? shippingAddress.complex_name
            : "",
          complexNumber: "",
          complexStreet: "",
          country: "South Africa",
          deliveryAddressFlag: "true",
          lineOne: "",
          postalCode: shippingAddress?.postcode ? shippingAddress.postcode : "",
          postalDeliveryFlag: "false",
          primaryAddressFlag: "false",
          privateBagNumber: "",
          province: shippingAddress?.region ? shippingAddress.region.label : "",
          ricaFlag: "false",
          seoid: "",
          streetName: shippingAddress?.street
            ? createStreetString(shippingAddress.street)
            : "",
          streetNo:
            shippingAddress?.street_number &&
            shippingAddress?.street_number !== ""
              ? shippingAddress.street_number
              : "00",
          suburb: shippingAddress?.suburb ? shippingAddress.suburb : "",
          unitNumber: shippingAddress?.unit_number
            ? shippingAddress.unit_number
            : "",
        },
      },
      otpToken: otpAuthtoken,
      listOfCSSHandsetDetailsList: {
        cssHandsetDetails: cssHandsetDetails
      }
    };
  };

  const placeOrder = async () => {
    try {
      showSpinner();
      if (currentJourneyType == journeyType.upgrade) {
        carrierCode = "flatrate";
        methodCode = "flatrate";
      }

      let shippingMethodData = await setShippingMethodsOnCartService(
        cartId,
        carrierCode,
        methodCode
      );

      if (!shippingMethodData.fail) {
        let paymentMethodData = await setPaymentMethod(
          cartId,
          totalZero,
          paymentMethodCode
        );
        if (!paymentMethodData.fail) {
          if (currentJourneyType == journeyType.upgrade) {
            submitUpgrade();
          } else {
            orderRouter();
          }
        } else {
          hideSpinner();
          handleApiFailure(
            `chk-mg-p-pm-${paymentMethodData?.status}`,
            paymentMethodData?.errors[0]?.message
          );
        }
      } else {
        hideSpinner();
        handleApiFailure(
          `chk-mg-p-sm-${shippingMethodData?.status}`,
          shippingMethodData?.errors[0]?.message
        );
      }
    } catch (err) {
      hideSpinner();
      handleApiFailure("chk-mg-p-sm-500", err?.message);
    }
  };

  /**
   * Upgrade customer
   *
   * @usage submit the data with request payload
   */
  const submitUpgrade = async () => {
    let inputObj = mapUpgradeData();

    if (Features.get("simOnlyEarlyUpgradeEnabled") && inputObj?.context === "UPGRADE"){
      inputObj.simOnlyUpgradeFlg = selectedUpgradeResponse?.simOnlyUpgradeFlg;
    }

    try {
      let responseData = await microService.put(
        "api",
        "customerDetails",
        inputObj,
        null,
        true
      );

      if (responseData?.response?.data) {
        orderRouter();
      } else {
        if (responseData?.error?.status) {
          fetchErrorDetails(
            `updateCustomerDetails_${responseData.error.status}`,
            `chk-dxl-p-ucd-${responseData.error.status}`,
            "UpdateCustomerDetails data not found"
          );
        } else if (
          responseData &&
          responseData?.response?.data?.responseCode == "ORDER_CREATION_ERROR"
        ) {
          hideSpinner();
          analyticsStoreError(
            responseData?.response?.data?.responseCode,
            "store reservation technical error"
          );
          fetchErrorDetails(
            labels.lbl_store_reservation_technical_error,
            "chk-dxl-p-ucd-500-store_reservation_technical_error",
            "store reservation technical error"
          );
        } else if (
          responseData &&
          responseData?.response?.data?.responseCode ==
            "ORDER_CREATION_NOSTORESTOCK"
        ) {
          hideSpinner();
          analyticsStoreError(
            responseData?.response?.data?.responseCode,
            "store reservation business error"
          );
          fetchErrorDetails(
            labels.lbl_store_reservation_business_error,
            "chk-dxl-p-ucd-424-store_reservation_business_error",
            "store reservation business error"
          );
        } else {
          fetchErrorDetails(
            labels.auth.errorCodes.api_time_out,
            `chk-dxl-p-ucd-504`,
            "UpdateCustomerDetails api time out"
          );
        }
      }
    } catch (err) {
      hideSpinner();
      handleApiFailure("chk-dxl-p-ucd-500", err?.message);
    }
  };

  const orderRouter = () => {
    let headers = {};
    let isPendedReferredOffline = false;
    let postOrder = JSON.parse(
      JSON.stringify(productOrderReq).replace(/\:null/gi, ':""')
    ); //replace null with "" for all attributes
    postOrder.productOrder[0].externalId = cartId;

    if (geoLocation && geoLocation?.storeDetails) {
      postOrder.productOrder[0].storeCode = geoLocation?.storeDetails;
    }

    if (applicationType !== "normal") {
      postOrder.productOrder[0].journeyType = currentJourneyType;
      postOrder.productOrder[0].contact.identificationID =
        authDetailsData?.idNumber;
      postOrder.productOrder[0].contact.identificationType =
        authDetailsData?.idType;
    }

    if (
      creditVettingDetails &&
      (creditVettingDetails?.resultCode ===
        labels.creditVetting.lbl_resultcode_pended ||
        creditVettingDetails?.resultCode ===
          labels.creditVetting.lbl_resultcode_pending ||
        creditVettingDetails?.resultCode ===
          labels.creditVetting.lbl_resultcode_referred ||
        creditVettingDetails?.resultCode ===
          labels.creditVetting.lbl_resultcode_offline ||
        creditVettingDetails?.resultCode
          ?.toUpperCase()
          .includes(labels.creditVetting.lbl_unprocessed))
    ) {
      postOrder.productOrder[0]["removeStandalone"] = true;
      isPendedReferredOffline = true;
    } else {
      postOrder.productOrder[0]["removeStandalone"] = false;
      isPendedReferredOffline = false;
    }

    if (vodAuthToken) {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-auth-jwt": `Bearer ${vodAuthToken}`,
        "x-magento-token": `Bearer ${authToken}`,
      };
    } else {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
    }

    const url = `${config.envConfigs[config.env].dxl.url}${
      config["api"]["postpaidProductOrder"]
    }`;

    axios
      .post(url, postOrder, {
        headers: headers,
      })
      .then((response) => {
        const { data } = response || {};
        if (data && data?.productOrders?.length) {
          let sessionMsisdn = sessionStorage.getItem('upgradeMsisdn');
          setPostOrderResponse(data.productOrders[0]);
          setCookieConsentWrapper(
            `cookie_${config.order_id}`,
            [config.cookie_category.strictly_necessary],
            `document.cookie='${config.order_id}=${data.productOrders[0]?.productOrderId};path=/'`
          );
          Cookie.remove("cart_id");
          if (isPendedReferredOffline) {
            let newCartId = response.data.productOrders[0].newCartId;
            setCookieConsentWrapper(
              "cart_id",
              [config.cookie_category.strictly_necessary],
              `document.cookie='cart_id=${newCartId};path=/'`
            );
            cartUpdateEvent();
          }
          continueDisable(true);

          if ((data.productOrders[0]?.niMigrationFeatureToggle === true && !data.productOrders[0]?.payment) || (data.productOrders[0]?.payment)) {
            hideSpinner();
            if (paymentOptionsEnabled) {
              navigate("payment");
            } else {
              navigate("paymentRedirect");
            }
          } else {
            hideSpinner();
            if (
              currentJourneyType === journeyType.upgrade &&
              (!selectedUpgradeMsisdn && !unMaskedMsisdn && !sessionMsisdn)
            ) {
              handleMissingMsisdn(
                "chk-dxl-p-po-200",
                "Upgrade journey missing msisdn"
              );
            } else {
              navigate("orderConfirmation");
            }
          }
          if (geoLocation && geoLocation?.storeDetails) {
            setStoreDetails(false);
            setChangeMethods(false);
            setChangeStore(false);
          }
        } else if (data && data?.responseCode == "ORDER_CREATION_ERROR") {
          hideSpinner();
          analyticsStoreError(
            data?.responseCode,
            "store reservation technical error"
          );
          fetchErrorDetails(
            labels.lbl_store_reservation_technical_error,
            "chk-dxl-p-ucd-500-store_reservation_technical_error",
            "store reservation technical error"
          );
        } else if (
          data &&
          data?.responseCode == "ORDER_CREATION_NOSTORESTOCK"
        ) {
          hideSpinner();
          analyticsStoreError(
            data?.responseCode,
            "store reservation business error"
          );
          fetchErrorDetails(
            labels.lbl_store_reservation_business_error,
            "chk-dxl-p-ucd-424-store_reservation_business_error",
            "store reservation business error"
          );
        } else {
          hideSpinner();
          handleApiFailure(
            "chk-dxl-p-po-200",
            "productOrderId not found in product orders array"
          );
        }
      })
      .catch((err) => {
        hideSpinner();
        checkOrderCreation(err);
        handleApiFailure("chk-dxl-p-po-500", err?.message);
      });
  };

  function checkOrderCreation(result) {
    if (result.messages) {
      let len = result.messages.length;
      for (let i = 0; i < len; i++) {
        if (
          result.messages[i].key == "orderStatus" &&
          getOrderCreated(result.messages[i].message)
        ) {
          Cookie.remove("cart_id");
        }
      }
    }
  }

  function handleMissingMsisdn(errorCode, errorMessage) {
    const pageName = `checkout: ${pageName}: ${customerStatus}`;
    const leadBucket = "upgrade_service_down";

    setPageErr({
      type: "error",
      title: labels.checkout.lbl_technical_error_title,
      desc: labels.checkout.lbl_technical_error_desc,
      primaryLabel: "Call me back",
      secondaryLabel: "Exit checkout",
      handlePrimaryClick: () =>
        handlePrimaryClick(
          `/forms/ecommerce?bucket=${leadBucket}`,
          "call me back"
        ),
      handleSecondaryClick: () => handleSecondaryClick(null, "exit checkout"),
      imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
      pageName: pageName,
      pageErrorType: "technical error",
      analyticsPageErrorCode: errorCode,
      analyticsPageErrorMessage: errorMessage,
    });
    navigate("pageError");
  }

  /**
   * Get the error display data
   * @usage Redirect to checkout error with error details
   */
  const fetchErrorDetails = async (resultCode, errorCode, errorMessage) => {
    const pageName = `checkout: ${pageName}: ${customerStatus}`;

    try {
      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "errorResultDetails",
        [resultCode]
      );

      setPageErr({
        type: "error",
        title: result[0].resultTitle,
        desc:
          result[0].resultText && result[0].resultText !== ""
            ? result[0].resultText
            : result[0].resultHTML,
        primaryLabel:
          result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
        primaryUrl:
          result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
        secondaryLabel:
          result[0].secondaryEnabled === "Yes"
            ? result[0].secondaryCTAText
            : null,
        secondaryUrl:
          result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
        handlePrimaryClick: () =>
          handlePrimaryClick(
            generateFormURL(
              result[0].primaryCTAURL,
              result[0].leadType,
              result[0].primaryCTAType
            ),
            result[0].primaryCTAText
          ),
        handleSecondaryClick: () =>
          handleSecondaryClick(
            generateFormURL(
              result[0].secondaryCTAURL,
              result[0].leadType,
              result[0].secondaryCTAType
            ),
            result[0].secondaryCTAText
          ),
        imgUrl: result[0].icon,
        pageName: pageName,
        analyticsPageErrorCode: errorCode,
        analyticsPageErrorMessage: errorMessage,
      });

      Logger.error(
        result[0].resultTitle || "fetchErrorDetails - ButtonPayment - error",
        "ButtonPayment",
        {
          response: JSON.stringify(result),
          function: "fetchErrorDetails",
          functionParams: {
            resultCode,
            errorCode,
            errorMessage
          }
        }
      );

      hideSpinner();
      //navigate to checkout page error
      navigate("pageError");
    } catch (error) {

      Logger.error(
        error,
        "ButtonPayment",
        {
          function: "fetchErrorDetails",
          functionParams: {
            resultCode,
            errorCode,
            errorMessage
          }
        }
      );

      setPageErr({
        type: "error",
        title: labels.auth.lbl_technical_error_title,
        desc: labels.auth.lbl_technical_error_desc,
        primaryLabel: "Call me back",
        secondaryLabel: "Exit checkout",
        handlePrimaryClick: () => handlePrimaryClick(null, "call me back"),
        handleSecondaryClick: () => handleSecondaryClick(null, "exit checkout"),
        imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
        pageName: pageName,
        analyticsPageErrorCode: errorCode,
        analyticsPageErrorMessage: errorMessage,
      });
      hideSpinner();
      //navigate to checkout page error
      navigate("pageError");
    }
  };

  function handleApiFailure(errorCode, errorMessage) {

    Logger.error(
      errorMessage,
      "ButtonPayment",
      {},
      { utag_code: errorCode || "unknown" }
    );

    if (applicationType == "normal" || cartDetails?.isMulti) {
      navigate("paymentError");
    } else {
      const pageName = `checkout: ${pageName}: ${customerStatus}`;
      setPageErr({
        type: "error",
        title: labels.checkout.lbl_technical_error_title,
        desc: labels.checkout.lbl_technical_error_desc,
        primaryLabel: "Call me back",
        secondaryLabel: "Exit checkout",
        handlePrimaryClick: () => handlePrimaryClick(null, "call me back"),
        handleSecondaryClick: () => handleSecondaryClick(null, "exit checkout"),
        imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
        pageName: pageName,
        pageErrorType: "technical error",
        analyticsPageErrorCode: errorCode,
        analyticsPageErrorMessage: errorMessage,
      });
      navigate("pageError");
    }
  }

  const handlePrimaryClick = (url, label) => {
    showSpinner();
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
      page_name: `${pageName}`,
    });

    if (url && label == "Choose another store") {
      setChangeStore(true);
      setChangeMethods(false);
      hideSpinner();
      navigate("delivery");
    } else {
      if (url) {
        router.push(`${urlPrefix}${url}`).then(() => {
          hideSpinner();
        });
      } else {
        router.push(`${urlPrefix}/forms/ecommerce`).then(() => {
          hideSpinner();
        });
      }
    }
  };

  const handleSecondaryClick = (url, label) => {
    showSpinner();
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
      page_name: `${pageName}`,
    });

    if (url && label == "Choose delivery option instead") {
      setChangeMethods(true);
      setStoreDetails(false);
      hideSpinner();
      navigate("delivery");
    } else {
      if (url) {
        router.push(`${urlPrefix}${url}`).then(() => {
          hideSpinner();
        });
      } else {
        router.push(`/`).then(() => {
          hideSpinner();
        });
      }
    }
  };

  function handleSubmit(event) {
    event.preventDefault();
    let linkUrl = applicationType == "normal" ? "checkout" : "post-checkout";
    let linkName =
      applicationType == "normal" ||
      (cartDetails?.isMulti && paymentOptionsEnabled)
        ? "continue"
        : currentJourneyType == journeyType.upgrade
        ? "submit upgrade"
        : "submit application";

    Analytics.link({
      link_type: "o",
      link_name: `checkout: ${pageName}: ${customerStatus}: ${linkName}`,
      link_url: `${urlPrefix}/${linkUrl}`,
    });
    placeOrder();
  }

  const analyticsStoreError = (errorType, errorMessage) => {
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    let types =
      errorMessage == "store reservation business error"
        ? "business error"
        : "service error";
    Analytics.view({
      page_event: "view",
      page_name: `${pageName}: ${types}`,
      page_form_event: "error",
      page_errors: errorType,
      page_error_type: "page",
    });
  };

  return (
    <>
      <input
        type="button"
        onClick={handleSubmit}
        className={`${styles["payment-button"]} ${
          btnSecure ? styles["secure"] : ""
        }`}
        name={btnLable}
        value={
          applicationType == "normal" &&
          totalZero == "true" &&
          methodCode == "freeshipping"
            ? "Confirm Order"
            : btnLable
        }
        disabled={btnDisabled}
        id="make-payment"
      />
    </>
  );
};

ButtonPayment.propTypes = {
  btnSecure: PropTypes.bool,
  btnLable: PropTypes.string,
  btnDisabled: PropTypes.bool,
  customerStatus: PropTypes.string,
};

ButtonPayment.defaultProps = {
  btnSecure: false,
  btnDisabled: false,
  btnClass: "",
};

const mapStateToProps = (state) => ({
  cartDetails: state.cartDetails,
  authDetailsData: state.checkoutDetails.authDetails,
  selectedUpgradeMsisdn: state.upgrade.selectedUpgradeMsisdn,
  selectedUpgradeResponse: state.upgrade.selectedUpgradeResponse,
  creditVettingDetails: state.checkoutDetails.creditVettingResult,
  unMaskedMsisdn: state.upgrade.unMaskedMsisdn,
  geoLocation: state.geoLocation,
  paymentMethodCode: state.checkoutDetails.paymentMethodCode,
});

const mapDispatchToProps = {
  setChangeStore,
  setStoreDetails,
  setChangeMethods,
  setPostOrderResponse,
};

export default connect(mapStateToProps, mapDispatchToProps)(ButtonPayment);
